import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../login.service';
import { RoleGroup, UserRole } from '../common/authorization/roles';

export const roleGuard: CanActivateFn = (route) => {
  const loginService = inject(LoginService);
  const router = inject(Router);
  const allowedRoles = route.data?.['allowedRoles'] as RoleGroup | undefined;

  if (allowedRoles?.length && loginService.hasAnyRole(allowedRoles)) {
    return true;
  }

  const redirect = loginService.hasAnyRole([UserRole.SuperAdmin])
    ? '/hospital'
    : '/dashboard';
  return router.createUrlTree([redirect]);
};
